module.exports = __webpack_public_path__ + "img/19_17.09b9031d.png";